// extracted by mini-css-extract-plugin
export default {"Container":"TagItem_Container__h2b2Y","Title":"TagItem_Title__sz9iF","CloseIcon":"TagItem_CloseIcon__YlpaK"};